export { default } from "./useGuidedHighlightingStudentAnswer";

export * from "./useGuidedHighlightingStudentAnswer";
